<div class="container d-flex justify-content-center align-items-center">
  <div class="error text-center">
    <div class=" error__text--number ">{{"ERRORS.SOMETHING_WENT_WRONG.CODE" | translate}}</div>
    <div class="error__text--big ">{{"ERRORS.SOMETHING_WENT_WRONG.BIG" | translate}}</div>
    <div class="error__text--small ">{{"ERRORS.SOMETHING_WENT_WRONG.SMALL" | translate}}</div>
  </div>
</div>
